import { Order } from '@/apis/order/interface';
import useOrderStatus from '../common/useOrderStatus';
import usePrescriptionDeny from './usePrescriptionDeny';
import useModal from '../common/useModal';

interface Props {
  order: Order;
}

const useOrderWaitingPaymentViewModel = ({ order }: Props) => {
  const {
    orderDenyReasons,
    cancelReason,
    setCancelReason,
    onSubmitOrderCancelByPharmacy,
    onSubmitPrescriptionDeny,
    PrescriptionDenyModal,
    onChangePrescriptionDenyModal
  } = usePrescriptionDeny(order.orderId);
  const { orderViewStatus, onChangeOrderViewStatus } = useOrderStatus({
    order
  });

  const [UpdateOrderPriceModal, setUpdateOrderPriceModal] =
    useModal(false);

  return {
    orderDenyReasons,
    cancelReason,
    setCancelReason,
    onSubmitOrderCancelByPharmacy,
    onSubmitPrescriptionDeny,
    PrescriptionDenyModal,
    onChangePrescriptionDenyModal,
    orderViewStatus,
    onChangeOrderViewStatus,
    UpdateOrderPriceModal,
    onChangeUpdateOrderPriceModal: setUpdateOrderPriceModal
  };
};

export default useOrderWaitingPaymentViewModel;
